import { useUserStore } from '@/store/user.ts'
import PropertyPopoverTrigger from '@/components/common/propertyPopoverOverlay/PropertyPopoverTrigger.tsx'
import OrgAvatar from '@/components/common/OrgAvatar.tsx'
import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { useTranslation } from 'react-i18next'
import PropertyPopover from '@/components/common/propertyPopoverOverlay/PropertyPopover.tsx'

export default function NavOrgsOverlay() {
  const { t } = useTranslation()
  const currOrg = useUserStore(state => state.currentOrganizationMembership)?.organization

  const properties: PopoverProperty[] = []
  const selected: string[] = []
  function onSelect() {}

  // Use PropertyPopover directly (not PopoverOverlay) so the org picker
  // opens anchored above the trigger on every screen size. PopoverOverlay
  // would render as a bottom-sheet on mobile — disorienting when the
  // trigger lives at the very bottom of the drawer (the sheet would
  // occlude the button you just tapped).
  return (
    <PropertyPopover
      className={`md:max-w-[calc(var(--sidebar-width)-32px)]`}
      properties={properties}
      fallbackMessage={t(`navigation.singleOrgWarning`)}
      addSelectedValue={onSelect}
      closeOnSelect={true}
      selectedValues={selected}
      popoverHeader={t('navigation.organizationsSearchLabel')}
      customTrigger={
        <PropertyPopoverTrigger
          className={`w-full justify-start`}
          variant={`outline`}
          label={currOrg?.name}
          icon={<OrgAvatar logosrc={currOrg?.icon?.contentUrlSmall} />}
        />
      }
    />
  )
}
